export default {
    poweredBy: "Energizado por"
}